<template>
  <div class="tw-flex tw-h-7 tw-items-center tw-justify-between">
    <template v-if="!header.isPlaceholder">
      <button
        class="tw-flex tw-items-center tw-h-7 tw-whitespace-nowrap tw-text-ellipsis tw-overflow-hidden"
        :class="{
          'tw-text-dorian-gray-300': loading,
          'tw-cursor-default': !header.column.getCanSort(),
        }"
        :data-test-id="`${testId}-${header.id}`"
        :disabled="loading"
        @click="
          header.column.getCanSort() &&
          header.column.getToggleSortingHandler()?.($event)
        "
      >
        <div
          class="tw-block tw-overflow-hidden tw-text-nowrap tw-text-ellipsis"
        >
          <slot />
        </div>
        <span
          v-if="header.column.columnDef.meta?.headerTooltip"
          v-tippy="{
            content: header.column.columnDef.meta?.headerTooltip,
            placement: 'top',
          }"
          class="tw-text-dorian-gray-200 tw-ml-2"
          @click.stop
        >
          <ClIconTablerInfoCircle :width="18" :height="18" />
        </span>
        <cl-th-sorting
          v-if="header.column.getCanSort()"
          :sort-direction="header.column.getIsSorted()"
        />
      </button>
    </template>
    <div
      v-if="header.column.getCanResize() && !header.column.getIsLastColumn()"
      class="tw-h-6 tw-cursor-col-resize tw-text-dorian-gray-100 hover:tw-text-dorian-gray-300 tw-pl-1 tw-outline-none tw-select-none"
      @mousedown="header.getResizeHandler()($event)"
      @dblclick="header.column.resetSize()"
    >
      <span>&#124;</span>
    </div>
  </div>
</template>

<script setup lang="ts" generic="T, U">
import { type Header } from "@tanstack/vue-table";

withDefaults(
  defineProps<{
    header: Header<T, U>;
    loading: boolean;
    testId?: string;
  }>(),
  {
    testId: "cl-table-header",
  },
);
</script>
